import { render, staticRenderFns } from "./AllAssesmentsPage.vue?vue&type=template&id=8caf8ec2&"
import script from "./AllAssesmentsPage.vue?vue&type=script&lang=js&"
export * from "./AllAssesmentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports